import {
  DesktopPageTab,
  DesktopPageTabs,
  MobilePageTab,
  MobilePageTabs,
} from "./styles.pageTabs";

const renderTabs = (Tabs, Tab, { tabs, activeKey, onChange, ariaLabel }) => (
  <Tabs role="tablist" aria-label={ariaLabel}>
    {tabs.map((tab) => (
      <Tab
        key={tab.key}
        type="button"
        role="tab"
        aria-selected={activeKey === tab.key}
        $active={activeKey === tab.key}
        onClick={() => onChange(tab.key)}
      >
        {tab.label}
      </Tab>
    ))}
  </Tabs>
);

/** tabs: [{ key, label }] */
export const DesktopPageTabsBar = (props) => renderTabs(DesktopPageTabs, DesktopPageTab, props);

export const MobilePageTabsBar = (props) => renderTabs(MobilePageTabs, MobilePageTab, props);
